import flow from 'lodash/flow';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { INLINE_DIALOG } from '@atlassian/jira-product-analytics-bridge';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getPortalId, isLoading } from '../state/selector/app-state/index.tsx';
import { ChannelsJsdView } from './view.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any) => ({
	isLoading: isLoading(state),
	portalId: getPortalId(state),
});

export const ChannelsJsd = flow(
	AnalyticsSource('jsdChannels', INLINE_DIALOG),
	// @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
	connect(mapStateToProps, {}),
)(ChannelsJsdView);
